import { app } from '@ibgroup-tws-webapps/ratio.ui';
import { useNavigation } from './useNavigation';
import { useProductHub } from './useProductHub';

function getFromQueryParam(): string {
  const urlParams = new URLSearchParams(window.location.hash);
  return urlParams.get('from') || 'Markets';
}

function sendAction(action: string, conidEx: number) {
  const from = getFromQueryParam();
  const payload = { action, data: { conidEx, from } };
  if (window.sendToCP) return window.sendToCP(payload);
  return app.send(payload);
}

function useContractActions() {
  const { openUrl } = useNavigation();
  const { isProductHubEnabled } = useProductHub();

  return {
    openQuoteDetails: (productConid: number, exchange?: string, conid?: number, side?: 'Y' | 'N') => {
      if (!isProductHubEnabled.value) {
        sendAction('quote_details', conid ?? productConid);
        return;
      }
      const params = new URLSearchParams();
      if (exchange) params.set('exchange', exchange);
      if (conid) {
        const paramName = side === 'N' ? 'conid_no' : 'conid_yes';
        params.set(paramName, String(conid));
      }
      const query = params.toString() ? `?${params.toString()}` : '';
      openUrl(`tws://forecast_trader2/${productConid}/product-details/contracts${query}`);
    },
    openContractsList: (productConid: number, exchange: string, { asUnderlying }: { asUnderlying?: boolean } = {}) => {
      if (!isProductHubEnabled.value) {
        const param = asUnderlying ? 'underlyingConid' : 'productConid';
        openUrl(`tws://forecast_trader2/contracts?${param}=${productConid}&exchange=${exchange}`);
        return;
      }
      openUrl(`tws://forecast_trader2/${productConid}/product-details/contracts?exchange=${exchange}`);
    },
  };
}

export default useContractActions;
